import DataGrid, { Column, FilterPanel, FilterRow, HeaderFilter, Sorting } from 'devextreme-react/data-grid';
import React, { useEffect, useRef, useState } from 'react';
import { Confirm } from 'semantic-ui-react';
import { SALESET_REGISTER_API_ENDPOINT, saleSetRegisterApi } from '../../../api/sf_saleset_register';
import { DangerButton, DefaultButton, PrimaryButton } from '../../../components/editor/button';
import ComboboxNamHoc from '../../../components/editor/cmb_namhoc';
import { HttpMethod, useCommonContext } from '../../../contexts/common';
import { showNotify } from '../../../helpers/toast';
import DanhSachDichVu from './danh-sach-dich-vu/DanhSachDichVu';
import DangKyDichVuDetailModal from './detail-modal/DangKyDichVuDetailModal';

const DangKyDichVu = ({ hocSinh, height }) => {
	const { canAccessTo, translate } = useCommonContext();
	const [filter, setFilter] = useState({ ts_hocsinh_id: 0, nam_hoc: '' });
	const [saleSetRegisterList, setSaleSetRegisterList] = useState([]);
	const [saleSetRegisterDetail, setSaleSetRegisterDetail] = useState({
		id: 0,
		ts_hocsinh_id: 0,
		nam_hoc: '',
		sf_saleset_register_type_id: 0,
	});
	const [isShowDetailModal, setIsShowDetailModal] = useState(false);
	const [isShowDeleteConfirm, setIsShowDeleteConfirm] = useState(false);

	const componentDidMount = useRef(false);

	const handleReloadData = async ({ ts_hocsinh_id, nam_hoc }) => {
		const res = await saleSetRegisterApi.Select({ nam_hoc, ts_hocsinh_id });
		if (!componentDidMount.current) return;
		if (res.is_success) {
			setSaleSetRegisterList(res.data);
		} else {
			setSaleSetRegisterList([]);
		}
	};

	const handleDelete = async () => {
		const res = await saleSetRegisterApi.Delete(saleSetRegisterDetail.id);
		if (!componentDidMount.current) return;
		if (res.is_success) {
			handleReloadData({ ...filter });
			setIsShowDeleteConfirm(false);
			showNotify({ type: 'success', text: 'Xóa dịch vụ đã đăng ký thành công.' });
		} else {
			showNotify({
				type: 'error',
				text: 'Có lỗi xảy ra',
			});
		}
	};

	const commandCellRender = (cell) => {
		return (
			<div>
				{canAccessTo(SALESET_REGISTER_API_ENDPOINT, HttpMethod.PUT) && (
					<span
						style={{ cursor: 'pointer' }}
						onClick={() => {
							setIsShowDetailModal(true);
							setSaleSetRegisterDetail({
								id: cell.data.id,
								ts_hocsinh_id: cell.data.ts_hocsinh_id,
								nam_hoc: cell.data.nam_hoc,
								sf_saleset_register_type_id: cell.data.sf_saleset_register_type_id,
							});
						}}
					>
						<i aria-hidden='true' className='icon edit'></i>{' '}
					</span>
				)}
				{/* {canAccessTo(SALESET_REGISTER_API_ENDPOINT, HttpMethod.DELETE) && ( */}
				<span
					style={{ cursor: 'pointer' }}
					onClick={() => {
						setIsShowDeleteConfirm(true);
						setSaleSetRegisterDetail({
							id: cell.data.id,
							ts_hocsinh_id: cell.data.ts_hocsinh_id,
							nam_hoc: cell.data.nam_hoc,
							sf_saleset_register_type_id: cell.data.sf_saleset_register_type_id,
						});
					}}
				>
					<i aria-hidden='true' className='icon trash'></i>{' '}
				</span>
				{/* )} */}
			</div>
		);
	};

	useEffect(() => {
		if (hocSinh) {
			setFilter({ ts_hocsinh_id: hocSinh.id, nam_hoc: hocSinh.nam_hoc });
		}
	}, [hocSinh]);

	useEffect(() => {
		componentDidMount.current = true;
		if (filter && filter.ts_hocsinh_id > 0 && filter.nam_hoc) {
			handleReloadData({ ts_hocsinh_id: filter.ts_hocsinh_id, nam_hoc: filter.nam_hoc });
		}
		return () => {
			componentDidMount.current = false;
		};
	}, [filter]);

	return (
		<div>
			<div className='row mb-2'>
				<div className='col-md-3'>
					<div className='dx-field-label'>{translate('Năm học')}</div>
					<br></br>
					<ComboboxNamHoc
						stylingMode='outlined'
						value={filter.nam_hoc}
						// readOnly = 'true'
						onValueChanged={(value) => setFilter((prev) => ({ ...prev, nam_hoc: value }))}
					/>
				</div>
			</div>
			<div className='row'>
				<div className='col-md-12'>
					<div
						style={{
							paddingBottom: 10,
							marginBottom: 10,
							fontWeight: 'bold',
							borderBottom: '1px solid #ececec',
						}}
					>
						<p>{translate('HÌNH THỨC NỘP PHÍ')}</p>
					</div>
					{saleSetRegisterList.length > 0 ? (
						<>
							<DataGrid
								keyExpr='id'
								dataSource={saleSetRegisterList}
								columnHidingEnabled={true}
								columnAutoWidth={true}
								showBorders={true}
								showColumnLines={true}
								showRowLines={true}
								rowAlternationEnabled={true}
								allowColumnResizing={true}
								columnResizingMode={'nextColumn'}
								hoverStateEnabled={true}
								focusedRowEnabled={false}
							// height={window.innerHeight - 150}
							>
								<Column
									visibleIndex={0}
									caption={'#'}
									cellRender={(cell) => <span>{cell.rowIndex + 1}</span>}
									width={40}
									alignment='center'
								/>
								<Column
									alignment='center'
									cellRender={commandCellRender}
									caption={translate('Thao tác')}
									width={85}
								></Column>
								<Column width='340' alignment='center' caption={translate('Năm học')} dataField='nam_hoc' />
								<Column
									alignment='center'
									caption={translate('Hình thức nộp')}
									dataField='sf_saleset_register_type_name'
								/>
								<Sorting mode='multiple' />
								<FilterRow visible={false} />
								<FilterPanel visible={false} />
								<HeaderFilter visible={false} />
							</DataGrid>
						</>
					) : (
						<>
							<PrimaryButton
								text={translate('Đăng ký hình thức nộp phí')}
								onClick={() => {
									setIsShowDetailModal(true);
									setSaleSetRegisterDetail({
										id: 0,
										ts_hocsinh_id: filter.ts_hocsinh_id,
										nam_hoc: filter.nam_hoc,
										sf_saleset_register_type_id: 0,
									});
								}}
							/>
						</>
					)}
				</div>
				{/* <div className='col-md-12'>
                   <DangKyXeBus ma_hs={hocSinh?.ma_hs} nam_hoc={filter.nam_hoc} />
                </div> */}
			</div>
			<br></br>
			<div className='row'>
				<div className='col-md-12'>
					<div
						style={{
							paddingBottom: 10,
							marginBottom: 10,
							fontWeight: 'bold',
							borderBottom: '1px solid #ececec',
						}}
					>
						<p>{translate('DANH SÁCH DỊCH VỤ')}</p>
					</div>

					<DanhSachDichVu ts_hocsinh_id={hocSinh.id} namHocSelected={filter.nam_hoc} height={height} />

					{/* {saleSetRegisterList.length > 0 ? (<>
                        <DanhSachDichVu ts_hocsinh_id={filter.ts_hocsinh_id}
                            namHocSelected={filter.nam_hoc} />
                    </>) : (<>
                        <p>{translate("Vui lòng đăng ký hình thức nộp phí để có thể lựa chọn các loại dịch vụ cho học sinh")}</p>
                    </>)} */}
				</div>
			</div>
			{isShowDetailModal && (
				<DangKyDichVuDetailModal
					sf_saleset_register={saleSetRegisterDetail}
					onSuccess={() => {
						setIsShowDetailModal(false);
						handleReloadData({ ...filter });
					}}
					onCancel={() => {
						setIsShowDetailModal(false);
					}}
				/>
			)}
			{isShowDeleteConfirm && (
				<Confirm
					open={true}
					dimmer={'blurring'}
					header={translate('Lưu ý')}
					content={translate('Bạn có chắc chắn muốn xóa dịch vụ đã đăng ký ?')}
					size='mini'
					cancelButton={() => {
						return (
							<DefaultButton
								text={'Đóng'}
								onClick={() => {
									setIsShowDeleteConfirm(false);
								}}
							/>
						);
					}}
					confirmButton={() => {
						return (
							<>
								<DangerButton
									text={translate('Xóa')}
									onClick={() => {
										handleDelete();
									}}
								/>
							</>
						);
					}}
				/>
			)}
		</div>
	);
};

export default DangKyDichVu;
